import { EOffersFromHistoryActionTypes } from '../../actions/offersFromHistory/types';
import { TRecentlyViewedOffer } from '../../types/recentlyViewedOffer';
import { TReduxActions } from '../../types/redux';

export interface IRecentlyViewedOfferState {
  data: TRecentlyViewedOffer[];
}

export const initialState = {
  data: [],
};

export const recentlyViewedReducer = (
  state: IRecentlyViewedOfferState = initialState,
  action: TReduxActions,
): IRecentlyViewedOfferState => {
  switch (action.type) {
    case EOffersFromHistoryActionTypes.Set:
      return {
        ...state,
        data: action.payload.data,
      };
    case EOffersFromHistoryActionTypes.ToggleFavorite:
      return {
        ...state,
        data: state.data.map(offer =>
          offer.offerId === action.payload.offerId ? { ...offer, isFavorite: action.payload.isFavorite } : offer,
        ),
      };
    default:
      return state;
  }
};
